import * as React from 'react'
import * as fs from './footer.module.scss'
import qrcodeDownload from '@images/qrcode-download-app.png'
import Logo from '@images/logo_white.png'

const Footer = () => {
  return (
    <footer className={fs.footer}>
      <div className={fs.footerTop}>
        <div className={fs.footerTopQrcode}>
          <div className={fs.footerTopQrcodeBox}>
            <img className={fs.footerTopQrcodeBoxImg} src={qrcodeDownload} alt="别样APP下载二维码" />
          </div>
          <div className={fs.footerTopQrcodeText}>
            <div>下载别样APP</div>
            <span>领</span>
            <span className={fs.footerTopQrcodeTextHighlight}>688元</span>
            <span>新人大礼包</span>
          </div>
        </div>
        <div className={fs.footerTopQrcode}>
          <div className={fs.footerTopQrcodeBox}>
            <img className={fs.footerTopQrcodeBoxImg} src={qrcodeDownload} alt="别样官方微信二维码" />
          </div>
          <div className={fs.footerTopQrcodeText}>
            <span>官方微信</span>
          </div>
        </div>
        <div className={fs.footerTopQrcode}>
          <div className={fs.footerTopQrcodeBox}>
            <img className={fs.footerTopQrcodeBoxImg} src={qrcodeDownload} alt="别样官方微博二维码" />
          </div>
          <div className={fs.footerTopQrcodeText}>
            <span>官方微博</span>
          </div>
        </div>
        <div className={fs.footerTopQrcode}>
          <div className={fs.footerTopQrcodeBox}>
            <img className={fs.footerTopQrcodeBoxImg} src={qrcodeDownload} alt="别样小程序二维码" />
          </div>
          <div className={fs.footerTopQrcodeText}>
            <span>别样小程序</span>
          </div>
        </div>
        <div className={fs.footerTopRight}>
          <img className={fs.footerTopRightLogo} src={Logo} alt="底部-logo" />
          <div className={fs.footerTopRightDescription}>下载别样APP，领 <span>688元</span> 新人大礼包</div>
          <div className={fs.footerTopRightAddress}>别样海外总部：298 S Sunnyvale Ave, STE 210 Sunnyvale, CA 94086</div>
          <div className={fs.footerTopRightAddress}>别样中国总部：上海市浦东新区张江高科科苑路399号10号楼12层</div>
        </div>
      </div>
      <div className={fs.footerBottom}>
        Copyright © 2015-2021, 上海别样秀数据科技有限公司, 上海市浦东新区张江高科科苑路399号10号楼12层, 021-61514616, All rights reserved. 沪ICP备18004034号
      </div>
    </footer>
  )
}

export default Footer